import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useT } from '../utils/i18n';
export function WhyUs() {
  const t = useT();
  return <section className="relative overflow-hidden border-t border-stone-200 bg-[#ffffff] py-12 transition-colors duration-300 dark:border-[#1b1b1b] dark:bg-[#222222] md:py-16" id="why-us" data-id="element-1879" data-mp="17kho7f462ym2">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/16b2545c-2634-4e9b-acb5-2a7d8d5de2b8.jpg" alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center grayscale" data-id="element-1880" data-mp="1gjcuer77o8pd" />
      <div className="pointer-events-none absolute inset-0 bg-white/95 dark:bg-[#222222]/95" aria-hidden="true" data-id="element-1881" data-mp="1qghgkr124466" />
      {/* Subtle decorative accent line */}
      <div className="absolute left-0 right-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-orange/40 to-transparent" data-id="element-1882" data-mp="3sazxpuqk1jgj" />

      <div className="relative z-10 mx-auto max-w-7xl px-4 font-[Roboto,_sans-serif] sm:px-6 lg:px-8" data-id="element-1883" data-mp="3nconhiwcl6xs">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="grid items-end gap-6 lg:grid-cols-12 lg:gap-12" data-id="element-1884" data-mp="3e8p078fdf7jk">
          <div className="lg:col-span-6" data-id="element-1885" data-mp="vvm7729a1n0">
            <div className="inline-flex items-center gap-2 mb-3" data-id="element-1886" data-mp="v3rrzkea9yb">
              <MapPin className="w-3.5 h-3.5 text-[#199A6E]" data-id="element-1887" data-mp="5ugqpiojj7h9" />
              <span className="font-bold uppercase tracking-[0.14em] text-[12px] text-[#199A6E] font-[Montserrat,_sans-serif]" data-id="element-1888" data-mp="5x2vxbnylawb">
                {'Local Experts'}
              </span>
            </div>

            <h2 className="text-[40px] sm:text-4xl md:text-5xl lg:text-6xl font-black text-stone-900 dark:text-white tracking-tight leading-[1.05]" data-id="element-1889" data-mp="etk88i827etn">
              <span className="font-[Inter,_sans-serif] font-[900] text-[#04A05C]" data-id="element-1890" data-mp="2gm9lgeebwnzp">
                We're the dispatcher.
              </span>
              <span className="font-[Inter,_sans-serif] font-[900] text-[#fffff9]" style={{
              WebkitTextStrokeWidth: '0px',
              WebkitTextStrokeColor: '#04A05C',
              WebkitTextFillColor: '#04A05C'
            }} data-id="element-1891" data-mp="3k01f7zjli0m8">
                We're the driver.
              </span>{' '}
              <span className="font-[Inter,_sans-serif] text-[#04A05C] text-[60px]" data-id="element-1892" data-mp="3ows3ha5k02iq">
                We are LOCAL.
              </span>
            </h2>
          </div>

          <div className="lg:col-span-6 lg:pl-6 lg:border-l lg:border-stone-200 dark:lg:border-white/10 pt-[10px] pb-[10px]" data-id="element-1893" data-mp="1sc2yganhb44">
            <p className="dark:text-stone-200 text-base md:text-lg leading-relaxed mb-4 text-stone-900 font-[400] font-[Inter,_sans-serif]" data-id="element-1894" data-mp="ghhxhqyjmd5o">
              {"Built in the 253, we're on the road across the 206 and 425 daily, delivering gravel, soil, bark, and landscape materials throughout King and Pierce Counties.  Same trucks, same drivers, same dispatcher every load.  \nWhen you call, you're talking directly to the people who will schedule and deliver your materials\u2014giving you better service and dependable local delivery every time.."}
            </p>
            <Link to="/local-vs-national" className="group inline-flex items-center gap-2 text-brand-orange hover:text-brand-orange/80 font-bold text-sm tracking-tight transition-colors" data-id="element-1895" data-mp="v3xfktltfrhz">
              <span className="text-stone-700 dark:text-stone-200 group-hover:text-brand-orange transition-colors text-[16px] font-[600] font-[Inter,_sans-serif]" data-id="element-1896" data-mp="z7da9kebrhs1">
                See how we stack up vs. national marketplaces
              </span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1 shrink-0" data-id="element-1897" data-mp="bgpqa0r4x1p4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}